{
  "button": {
    "hide": "Hide",
    "show": "Show",
    "rememberMe": "Remember me",
    "forgotPassword": "Forgot password",
    "termsAndConditions": "Terms & Conditions",
    "seeMore": "See More",
    "search": "Search"
  },
  "title": {
    "signin": "Sign in",
    "signingIn": "Signing in",
    "loginWithOtherAccount": "Login with other account",
    "continueWithGG": "Continue with Google",
    "signUp": "Sign up",
    "signingUp": "Signing up",
    "continueWithKaKao": "Continue with KaKaoTalk",
    "home": "Home",
    "tours": "Tours",
    "aboutUs": "About us",
    "dashboard": "Dashboard",
    "myProfile": "My Profile",
    "signout": "Sign out",
    "customerSupport": "Customer Support",
    "dropUsAnEmail": "Drop Us an Email",
    "locations": "Locations",
    "followUsOn": "Follow us on"
  },
  "msg": {
    "registeredSuccess": "Registered successfully"
  },
  "valid": {
    "required": "This field is required",
    "requiredInfor": "Invalid information. Please re-enter.",
    "passwordsDoNotMatch": "Passwords do not match",
    "mustAcceptTerms": "You need to accept the terms and conditions to continue."
  },
  "field": {
    "phone": "Phone number",
    "password": "Password",
    "confirmPassword": "Confirm password",
    "userName": "Full Name",
    "email": "Email"
  },
  "or": "Or",
  "noAccount": "Don't have an account",
  "haveAccount": "Already have an account",
  "accept": "Accept",
  "footerSlogan": "Our mission is to provide you with a seamless and enjoyable travel experience, whether you're planning a relaxing getaway, an exciting adventure, or a memorable tour with your loved ones.",
  "whereDoYouWantToGo?": "Where do you want to go?",
  "departureDate": "Departure date",
  "travellerroom": "Traveller"
}
